import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=31759c98&scoped=true&lang=pug&"
import script from "./overlay.vue?vue&type=script&lang=js&"
export * from "./overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=31759c98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31759c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('31759c98', component.options)
    } else {
      api.reload('31759c98', component.options)
    }
    module.hot.accept("./overlay.vue?vue&type=template&id=31759c98&scoped=true&lang=pug&", function () {
      api.rerender('31759c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/others/overlay.vue"
export default component.exports